import React from "react";
import ChatSearch from "./ChatSearch";
import Online from "./Online";
import RecentChats from "./RecentChats";

const LeftSideChat = ({
  selectChatHandler = () => {},
  chatList = [],
  onSearch = () => {},
  onChatListLoad = () => {},
  searchValue,
  activeChatId,
}) => {
  return (
    <>
      {/* <div className="text-xl font-medium intro-y">Chats</div> */}
      <ChatSearch onSearch={onSearch} searchValue={searchValue} />
      {/* <Online /> */}
      <RecentChats
        selectChatHandler={selectChatHandler}
        chatList={chatList}
        activeChatId={activeChatId}
        onChatListLoad={onChatListLoad}
      />
    </>
  );
};

export default LeftSideChat;
